import React from 'react';
import * as Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import * as mutationActions from '../../model/action-creators/mutation-actions'
import Editor from './editor/Editor';
import ItemLstTable from './ItemLstTable';
import {Keys} from '../../model/constants';

const workSessionAction = {
    id: 'workSessionAction',
    label: 'W',
    handleSelection: (editorId, selection, currentMutations, dispatch) => {

        const itemMutations = currentMutations.get(Keys.MutationType.ITEM); // expect map
        dispatch(mutationActions.doToggleMultiple(
            editorId,
            Keys.MutationType.ITEM,
            selection,
            itemMutations,
            Keys.Item.IN_WORK_SESSION,
            true)
        );
    },
    handleItemClick: (editorId, itemType, item, currentMutations, dispatch) => {
        const mutation = currentMutations.getIn([itemType, item.get(Keys.ID)], Immutable.Map()); // NOTE on not using editorID in path (mutations are already sliced for us)
        dispatch(mutationActions.doTogglePlain(
            editorId,
            itemType,
            item,
            mutation,
            Keys.Item.IN_WORK_SESSION,
            true)
        );
    },
    isEnabled: (type, modifiers) => true, // supports all types
    shouldShow: (modifiers) => true, // show regardless of keyboard modifiers
};
const hiddenAction = {
    id: 'hiddenAction',
    label: 'H',
    handleSelection: (editorId, selection, currentMutations, dispatch) => {

        const itemMutations = currentMutations.get(Keys.MutationType.ITEM); // expect map
        dispatch(mutationActions.doToggleMultiple(
            editorId,
            Keys.MutationType.ITEM,
            selection,
            itemMutations,
            Keys.Item.HIDDEN,
            true)
        );
    },
    handleItemClick: (editorId, itemType, item, currentMutations, dispatch) => {
        const mutation = currentMutations.getIn([itemType, item.get(Keys.ID)], Immutable.Map()); // NOTE on not using editorID in path (mutations are already sliced for us)
        dispatch(mutationActions.doTogglePlain(
            editorId,
            itemType,
            item,
            mutation,
            Keys.Item.HIDDEN,
            true)
        );
    },
    isEnabled: (type, modifiers) => true, // supports all types
    shouldShow: (modifiers) => true, // show regardless of keyboard modifiers
};

/*
TODO: Make this difficulty items
const generateGroupAction = (actionId, label, valueToSet) => {
    const prop = Keys.Assignee.GROUPS;
    return {
        id: actionId,
        label: label,
        handleSelection: (editorId, selection, currentMutations, dispatch) => {

            const itemMutations = currentMutations.get(Keys.MutationType.ASSIGNEE); // expect map
            dispatch(mutationActions.doToggleInMultipleSets(
                editorId,
                Keys.MutationType.ASSIGNEE,
                selection,
                itemMutations,
                prop, valueToSet))
        },
        handleItemClick: (editorId, itemType, item, currentMutations, dispatch) => {
            // OR should this be done from the editor?
            const mutation = currentMutations.getIn([itemType, item.get(Keys.ID)], Immutable.Map()); // NOTE on not using editorID in path (mutations are already sliced for us)
            dispatch(mutationActions.doToggleInSet(
                editorId,
                itemType,
                item,
                mutation,
                prop,
                valueToSet)
            );
        },
        isEnabled: (type, modifiers) => true, // supports all types
        shouldShow: (modifiers) => true, // show regardless of keyboard modifiers
    }
}
*/
class ItemLstPanel extends React.Component {

    getActions() {
        let actions =  [];
        if(!this.props.currentWorkSession.isEmpty()) {
            actions.unshift(workSessionAction, hiddenAction);
        }
        return actions;
    }

    render() {
        return (
        <Editor actions={this.getActions()}
                mutations={this.props.mutations}
                editorId={Keys.EditorIds.ITEMS_PAGE}
                dispatch={this.props.dispatch}
                onSave={() => this.props.dispatch(mutationActions.saveEditor(Keys.EditorIds.ITEMS_PAGE))}

        >
            <ItemLstTable
                items={this.props.items}
                mutations={this.props.mutations}
                currentWorkSession={this.props.currentWorkSession}
            />
        </Editor>

        )
    }
}

ItemLstPanel.propTypes = {

    items:ImmutablePropTypes.map.isRequired,
    mutations:ImmutablePropTypes.map.isRequired,
    currentWorkSession:ImmutablePropTypes.map.isRequired,
    dispatch:React.PropTypes.func.isRequired,
};


export default ItemLstPanel



// WEBPACK FOOTER //
// ./src/ui/components/ItemLstPanel.js